import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_BOOTSTRAP_LISTENER, APP_INITIALIZER, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatNativeDateModule } from '@angular/material/core';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySliderModule as MatSliderModule } from '@angular/material/legacy-slider';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CovalentDialogsModule } from '@covalent/core/dialogs';
import { EffectsModule } from '@ngrx/effects';
import { RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { OktaAuthModule } from '@okta/okta-angular';
import { ApolloModule } from 'apollo-angular';
import { TypedReactiveFormsModule } from '@gmrappdev/formsafe';
import { PubnubEntityStoreEffects } from 'src/app/ops/pubnub-entity-store.effects';
import { Four04PageComponent } from 'src/app/pages/components/four04-page/four04-page.component';
import { buildTcsPermissions } from 'src/app/shared/authorization/permissions';
import { SplashScreenComponent } from 'src/app/shared/components/splash-screen/splash-screen.component';
import { TcsLoggingModule } from 'src/app/shared/tcs-logging/tcs-logging.module';
import { environment } from 'src/environments/environment';
import { AmgAddressModule } from 'src/lib/amg-address/amg-address.module';
import { PERMISSIONS_CONFIG } from 'src/lib/amg-authorization/permissions.model';
import { AmgHumanizeModule } from 'src/lib/amg-humanize/amg-humanize.module';
import { AmgPubnubModule } from 'src/lib/amg-pubnub/amg-pubnub.module';
import { TcsClientSyncModule } from 'src/lib/tcs-client-sync/tcs-client-sync.module';
import { ImpersonationInterceptor } from 'src/lib/tcs-identity/impersonation.interceptor';
import { oktaConfigProvider } from 'src/lib/tcs-identity/okta-config.provider';
import { TcsIdentityModule } from 'src/lib/tcs-identity/tcs-identity.module';
import { TcsToastModule } from 'src/lib/tcs-toast/tcs-toast.module';
import { AuthStoreEffects } from 'src/store/auth/auth-store.effects';
import { reducerProvider, reducerToken } from 'src/store/reducers';
import { CustomSerializer } from 'src/store/router/router-store';
import { TcsLoadingModule } from 'src/lib/tcs-loading/tcs-loading.module';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { monacoConfig } from 'src/lib/tcs-editor/editor/editor.component';
import { MatSelectModule } from '@angular/material/select';
import { AttachmentUploaderService } from 'src/lib/tcs-attachment-uploader/attachment-uploader.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AuthenticationInterceptor } from '../../lib/tcs-identity/authentication.interceptor';
import { AppRoutingModule } from '../app-routing.module';
import { PassdownLogEffects } from '../ops/ops-dialogs/passdown-log-dialog/passdown-log-effects';
import { AppBootstrapService, bootstrapApp } from './app-bootstrap.service';
import { AppInitializerService, initApp } from './app-initializer.service';
import { UnauthorizedPageComponent } from './components/unauthorized-page/unauthorized-page.component';

@NgModule({
  imports: [
    // Angular
    BrowserModule,
    BrowserAnimationsModule,
    TypedReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),

    FlexLayoutModule,

    // Angular Material
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatSelectModule,
    MatMenuModule,
    MatAutocompleteModule,
    CovalentDialogsModule,

    // Apollo/GraphQL
    ApolloModule,
    // HttpLinkModule,

    // NGRX
    EffectsModule.forRoot([AuthStoreEffects, PubnubEntityStoreEffects, PassdownLogEffects]),
    StoreModule.forRoot(reducerToken),
    StoreRouterConnectingModule.forRoot(),
    // environment.production
    //   ? []
    //   : StoreDevtoolsModule.instrument({
    //       maxAge: 25,
    //     }),

    // TOOD: Possibly re-enable after memory leak is fixed.
    // StoreDevtoolsModule.instrument({
    //   maxAge: 25,
    // }),

    // TCS

    AmgPubnubModule,
    AmgHumanizeModule,
    AmgAddressModule,
    AppRoutingModule,
    TcsClientSyncModule,
    TcsToastModule.forRoot(),
    TcsLoadingModule,

    // App infrastructure
    TcsLoggingModule,

    // Okta
    OktaAuthModule,
    MonacoEditorModule.forRoot(monacoConfig),
  ],
  declarations: [UnauthorizedPageComponent, Four04PageComponent, SplashScreenComponent],
  providers: [
    {
      provide: APP_BOOTSTRAP_LISTENER,
      useFactory: bootstrapApp,
      deps: [AppBootstrapService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [AppInitializerService],
      multi: true,
    },
    reducerProvider,
    {
      provide: RouterStateSerializer,
      useClass: CustomSerializer,
    },
    {
      provide: PERMISSIONS_CONFIG,
      useFactory: buildTcsPermissions,
    },
    oktaConfigProvider,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ImpersonationInterceptor,
      multi: true,
    },
    AttachmentUploaderService,
  ],
  exports: [
    TcsIdentityModule,
    ApolloModule,
    SplashScreenComponent,
    BrowserModule,
    RouterModule,
    FlexLayoutModule,
    TcsToastModule,
  ],
})
export class CoreModule {}
